import React, { useState } from 'react';

import {
  StripeAccountLinkRequest,
  StripeConnectedAccountInfo,
} from '@flipdish/api-client-typescript';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { Translate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { compose } from 'recompose';

import { createStripeConnectedAccountLink } from '../banking.actions';

export interface StripeAccount {
  stripeAccount: StripeConnectedAccountInfo;
  bankAccountId?: number;
}

type Props = StripeAccount & MappedDispatch & RouteComponentProps;

const VerifyStripeButton: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const { stripeAccount, setAccountLink, bankAccountId, location, history } = props;

  const [isLoading, setIsLoading] = useState(false);

  const getReturnUrl = () => {
    const currentWindow = window.location.href;

    return bankAccountId
      ? currentWindow.replace('/bank-accounts/new', `/bank-accounts/${bankAccountId}`)
      : currentWindow;
  };

  const getBankAccountUrl = () =>
    bankAccountId
      ? location.pathname.replace('/bank-accounts/new', `/bank-accounts/${bankAccountId}`)
      : location.pathname;

  const stripeAccountLinkRequest = {
    StripeId: stripeAccount.StripeId,
    ReturnUrl: getReturnUrl(),
    Collect: StripeAccountLinkRequest.CollectEnum.EventuallyDue,
    Type: StripeAccountLinkRequest.TypeEnum.Onboarding,
  } as StripeAccountLinkRequest;

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const result = await setAccountLink(stripeAccountLinkRequest);
      if (result && (result as any).Url) {
        window.history.replaceState(null, '', getBankAccountUrl());
        window.location.href = (result as any).Url;
      } else {
        setIsLoading(false);
        history.push(getBankAccountUrl());
      }
    } catch {
      setIsLoading(false);
      history.push(getBankAccountUrl());
    }
  };

  return (
    <Button
      onClick={handleSubmit}
      color="primary"
      data-fd="Verify_with_stripe_button"
      style={{ letterSpacing: '1.25px' }}
      variant="contained"
      disabled={isLoading}
      startIcon={isLoading ? <CircularProgress size={24} color="inherit" /> : <OpenInNewIcon />}
    >
      <Translate id="Verify_with_stripe" />
    </Button>
  );
};

type MappedDispatch = ReturnType<typeof mapDispatchToProps>;
function mapDispatchToProps(dispatch: ThunkDispatch) {
  return {
    setAccountLink: (stripeAccountLinkRequest) => {
      return dispatch(createStripeConnectedAccountLink(stripeAccountLinkRequest, true));
    },
  };
}

export default compose<Props, StripeAccount>(
  withRouter,
  connect(null, mapDispatchToProps)
)(VerifyStripeButton);
